var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tipMessage)?_c('el-popover',{attrs:{"trigger":"hover","placement":"top","content":_vm.tipMessage}},[_vm._t("default",null,{slot:"reference"})],2):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }